<template>
  <div>
    <HomeTitle/>
  </div>
</template>

<script>
import HomeTitle from "@/components/HomeTitle.vue";
export default {
  name: 'HomeView',
  components: {
    HomeTitle
  }
}
</script>
